<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <ErrorMessage
      v-if="errors.load"
      :error="errors.load"
      class="max-w-sm mx-auto"
    />

    <Loader v-if="loading" />
    <div v-else-if="data.chapter.id">
      <PageTitle v-bind:title="title" v-bind:admin="false" />

      <ErrorMessage
        v-if="errors.any"
        :error="errors.any"
        class="max-w-sm mx-auto"
      />

      <div class="relative py-16 bg-white overflow-hidden">
        <div
          class="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full"
        >
          <div
            class="relative h-full text-lg max-w-prose mx-auto"
            aria-hidden="true"
          >
            <svg
              class="absolute top-12 left-full transform translate-x-32"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
              />
            </svg>
            <svg
              class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
              />
            </svg>
            <svg
              class="absolute bottom-12 left-full transform translate-x-32"
              width="404"
              height="384"
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="d3eb07ae-5182-43e6-857d-35c643af9034"
                  x="0"
                  y="0"
                  width="20"
                  height="20"
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x="0"
                    y="0"
                    width="4"
                    height="4"
                    class="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width="404"
                height="384"
                fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
              />
            </svg>
          </div>
        </div>
        <div class="relative px-4 sm:px-6 lg:px-8">
          <div class="text-lg max-w-prose mx-auto">
            <h2>
              <span
                v-if="data.status_id == 1"
                class="block text-base text-center text-green-600 font-semibold tracking-wide uppercase"
                >в работе</span
              >
              <span
                v-if="data.status_id == 5"
                class="block text-base text-center text-indigo-600 font-semibold tracking-wide uppercase"
                >завершено</span
              >
              <span
                class="mt-2 block text-3xl text-center leading-8 font-bold tracking-tight text-gray-900 sm:text-3xl"
                >Введение</span
              >
            </h2>
            <p
              v-html="brFunc(data.chapter.description)"
              class="mt-8 text-xl text-gray-500 leading-8"
            ></p>

            <div class="mt-4">
              <!-- this block unstyled yet -->
              <div v-if="data.status_id == 5">
                <!-- "глава пройдена! можете откатить результаты": -->
                <Winner
                  v-bind:message="tip_messages[0]+' Оценка за тестирование - '+data.grade+'%'"
                  v-bind:type="0"
                  @unfinish:chapter="unfinishChapter"
                />
              </div>
              <div v-if="!data.exams.length && data.canBeFinished">
                <!-- "изучите материал, и нажмите 'завершить'": -->
                <Tip v-bind:message="tip_messages[1]" />
              </div>
              <div v-if="data.exams.length && data.canBeFinished">
                <!-- "вы прошли тестирование, теперь нажмите 'завершить главу'": -->
                <!-- <Winner v-bind:message="tip_messages[3]" v-bind:type="0" /> -->
                <ChapterMarkAndFinish
                  v-if="data.canBeFinished"
                  v-on:need-to-reload="loadData()"
                  v-bind:chapter="data.chapter"
                  v-bind:caption="'Тестирование завершено!'"
                />
              </div>
              <div
                v-if="
                  data.exams.length &&
                  !data.canBeFinished &&
                  data.status_id == 1
                "
              >
                <!-- "изучите материал, и переходите к тестированию": -->
                <Tip v-bind:message="tip_messages[2]" />
              </div>
              <!-- this block unstyled yet  END -->
            </div>
          </div>

          <div class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
            <span
              class="mt-2 block text-3xl text-center leading-8 font-bold tracking-tight text-gray-900 sm:text-3xl mb-4"
              >Материал к изучению</span
            >
            <div class="" v-html="data.chapter.text"></div>
          </div>

          <div>
            <!-- Если у главы нет тестирования: -->
            <div
              v-if="
                data.status_id != 5 &&
                !data.exams.length &&
                data.canBeFinished
              "
            >
              <ChapterMarkAndFinish
                v-if="data.canBeFinished"
                v-on:need-to-reload="loadData()"
                v-bind:chapter="data.chapter"
                v-bind:caption="'К этой главе нет тестирования.'"
              />
            </div>

            <!-- Если есть тестирование, нам в любом случае нужно иметь возможность перейти к нему: -->
            <div
              v-if="data.exams.length"
              class="w-full lg:w-1/2 mx-auto p-4 mt-8 text-center"
            >
              <router-link
                v-if="data.status_id == 5"
                :to="{ name: 'testing', params: { id: data.chapter.id } }"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <!-- Просмотреть результаты тестирования -->
                  Пройти тестирование
              </router-link>
              <!--
              <router-link
                v-else-if="data.canBeFinished"
                :to="{ name: 'questions', params: { id: data.chapter.id } }"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >Просмотреть результаты тестирования</router-link
              >
              -->

              <div
                v-else-if="!data.canBeFinished"
                class="bg-white shadow sm:rounded-lg"
              >
                <div class="px-4 py-5 sm:p-6">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Тестирование к главе
                  </h3>
                  <div class="mt-5">
                    <div
                      class="rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between"
                    >
                      <div class="sm:flex sm:items-start">
                        <svg
                          class="h-8 w-auto sm:flex-shrink-0 sm:h-6"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                          />
                        </svg>
                        <div class="mt-3 sm:mt-0 sm:ml-4">
                          <div class="text-sm font-medium text-gray-900">
                            <span
                              >Вопросов в тестировании:
                              {{ data.exams.length }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0">
                        <router-link
                          :to="{
                            name: 'testing',
                            params: { id: data.chapter.id },
                          }"
                          class="inline-flex items-center px-4 py-2 no-underline border border-gray-300 shadow-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                          >Перейти к тестированию</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import ErrorMessage from "@/components/ErrorMessage";
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import Tip from "@/components/Tip";
import Winner from "@/components/Winner";
import ChapterMarkAndFinish from "@/components/ChapterMarkAndFinish";
//import jQuery from 'jquery'
export default {
  components: {
    Loader,
    ErrorMessage,
    BreadCrumbs,
    PageTitle,
    Tip,
    Winner,
    ChapterMarkAndFinish,
  },
  data() {
    return {
      loading: true,
      // data: [],
      data: {},
      errors: { load: "", any: "" },
      title: "",
      bcrumbs: [],
      tip_messages: [
        // "Глава пройдена! Если хотите, Вы можете откатить все результаты и пройти главу заново.",
        "Глава пройдена!",
        'Внимательно изучите теоретический материал, а затем нажмите "Завершить Главу".',
        "Внимательно изучите теоретический материал, а затем переходите к тестированию.",
        'Поздравляем! Вы прошли тестирование! Теперь нажмите "Завершить Главу"!',
      ],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("chapters/" + this.$route.params.id);
        this.data = response.data;
        this.title = this.data.chapter.name;
        this.bcrumbs = response.data.bcrumbs;

        // this.data.questions = []
        //this.data.status_id = 5
        // this.data.canBeFinished = false

        this.loading = false;
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.load = e.response.data.error;
        } else if (e.response.status == 401) {
          this.errors.load = e.response.data.error;
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },

    /*
            Эта ф-ция переехала в ChapterMarkAndFinish.
            Тут по идее не нужна.
        async finishChapter() {
            this.errors.any = ''
            try {
                let response = await axios.post('chapters/'+this.$route.params.id+'/finish')
                if (response.status == 200) {
                    this.loading = true
                    this.loadData()
                }
            }
            catch(e) {         
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Неизвестная ошибка при завершении Главы."
                }
            }
        },
        */

    async finishChapterFORCED() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "chapters/" + this.$route.params.id + "/finishFORCED"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при завершении Главы.";
        }
      }
    },

    async unfinishChapter() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "chapters/" + this.$route.params.id + "/unfinish"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при 'открытии' Главы.";
        }
      }
    },
  },
};
</script>


<style scoped>
.li_test {
  /* border: 2px solid red; */
  list-style: none;
  background: url(/icons/arrow.png) no-repeat left 50%;
  padding-left: 25px;
}
</style>